var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionToAuto',{attrs:{"move":"","zoom":""}},[(_vm.dismissed == false)?_c('div',[_c('div',{class:'alert alert-' + _vm.type + ' alert-dismissible'},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.dismiss}},[_vm._v("×")]),_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }